import VueSweetAlert from './vue-sweetalert'

export default VueSweetAlert


// WEBPACK FOOTER //
// ./src/main.js